/* import __COLOCATED_TEMPLATE__ from './notifications-filter-header.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import { fmt } from "discourse/lib/computed";
import discourseComputed from "discourse/lib/decorators";
import DropdownSelectBoxHeaderComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-header";
const NotificationsFilterHeader = dt7948.c(class NotificationsFilterHeader extends DropdownSelectBoxHeaderComponent {
  static {
    dt7948.g(this.prototype, "label", [fmt("value", "user.user_notifications.filters.%@")]);
  }
  #label = (dt7948.i(this, "label"), void 0);
  caretIcon(isExpanded) {
    return isExpanded ? "caret-up" : "caret-down";
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [discourseComputed("selectKit.isExpanded")]);
  }
}, [classNames("notifications-filter-header", "btn-flat")]);
export default NotificationsFilterHeader;